import React from 'react';
import { Skeleton } from 'antd';
import type { StudioMode } from './DetailView';

/**
 * Full-page loading placeholder for the Analysis Studio, shown while the real
 * session + roster load (before `isReady`). It reuses the SAME layout classes as
 * the live shell (`studio2__topbar` / `__body` / `__rail` / `__workspace`) and is
 * rendered inside the same measured `.studio2` container, so swapping it for the
 * real content on load causes no layout jump. The Rail column is cohort-only,
 * mirroring the live shell.
 */
const StudioSkeleton: React.FC<{ mode: StudioMode }> = ({ mode }) => (
  <>
    <div className="studio2__topbar">
      <Skeleton.Input active size="small" style={{ width: 260 }} />
    </div>
    <div className="studio2__body">
      {mode === 'cohort' && (
        <div className="studio2__rail">
          <Skeleton active title paragraph={{ rows: 2 }} />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 8 }}
            style={{ marginTop: 16 }}
          />
        </div>
      )}
      <div className="studio2__workspace">
        <Skeleton active title paragraph={{ rows: 3 }} />
        <Skeleton
          active
          title
          paragraph={{ rows: 6 }}
          style={{ marginTop: 24 }}
        />
      </div>
    </div>
  </>
);

export default StudioSkeleton;
